import { connect } from 'react-redux';
import ViewEntityPipelineButton from './ViewEntityPipelineButton';

export default connect(null)(ViewEntityPipelineButton);
